import {
  ShippingInfoCardRowWrapper,
  AddressCard,
  AddressHeader,
  AddressName,
  DefaultLabel,
  AddressLines,
  AddressActions,
  StyledAddressActionItem,
} from "../../../../../utils/styled";
import { RowDataObject } from "../../../../../types";
import { useIntl } from "react-intl";

interface AddressCardItemProps {
  rowIndex: number;
  address: RowDataObject;
  fullAddress: string;
  isDefault?: boolean;
  isReadOnly?: boolean;
  onEdit?: () => void;
  onDelete?: () => void;
  onSetAsDefault?: () => void;
  onImport?: () => void;
}

export function AddressCardItem({
  rowIndex,
  address,
  fullAddress,
  isDefault = false,
  isReadOnly = false,
  onEdit,
  onDelete,
  onSetAsDefault,
  onImport,
}: Readonly<AddressCardItemProps>): JSX.Element {
  const ADDRESS_NAME = "addr_nm";
  const intl = useIntl();

  return (
    <ShippingInfoCardRowWrapper key={rowIndex}>
      <AddressCard>
        <AddressHeader>
          <AddressName>{address[ADDRESS_NAME] as string}</AddressName>
          {isDefault && <DefaultLabel>Default</DefaultLabel>}
        </AddressHeader>

        <AddressLines>{fullAddress}</AddressLines>

        {!isReadOnly && (
          <AddressActions>
            {onEdit && (
              <StyledAddressActionItem
                dataTestId={`edit-${rowIndex}-row-button`}
                text={intl.formatMessage({
                  id: "button.edit",
                  defaultMessage: "Edit",
                })}
                size="small"
                onClick={onEdit}
                variant="text"
              />
            )}
            {onDelete && (
              <StyledAddressActionItem
                dataTestId={`delete-${rowIndex}-row-button`}
                text={intl.formatMessage({
                  id: "button.delete",
                  defaultMessage: "Delete",
                })}
                size="small"
                onClick={onDelete}
                variant="text"
              />
            )}
            {onSetAsDefault && (
              <StyledAddressActionItem
                dataTestId={`set-as-default-${rowIndex}-row-button`}
                text={intl.formatMessage({
                  id: "button.setAsDefault",
                  defaultMessage: "Set As Default",
                })}
                size="small"
                onClick={onSetAsDefault}
                variant="text"
              />
            )}
            {onImport && (
              <StyledAddressActionItem
                dataTestId={`import-${rowIndex}-row-button`}
                text={intl.formatMessage({
                  id: "button.import",
                  defaultMessage: "Import",
                })}
                size="small"
                onClick={onImport}
                variant="text"
              />
            )}
          </AddressActions>
        )}
      </AddressCard>
    </ShippingInfoCardRowWrapper>
  );
}
